import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/resendActivationLink
export const resendActivationLink = async (): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/resend_activation_link`)
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
